module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "open": _vm.isOpen
    },
    on: {
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(this.currentStep == 1) ? _c('div', {
    staticClass: "wizard step-1"
  }, [_c('step-one', {
    attrs: {
      "item": _vm.item
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.currentStep == 2) ? _c('div', {
    staticClass: "wizard step-2"
  }, [_c('step-two', {
    attrs: {
      "item": _vm.item,
      "leadMasks": _vm.leadMasks,
      "businesskits": _vm.businesskits
    },
    on: {
      "create": function($event) {
        return _vm.create()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.currentStep == 3) ? _c('div', {
    staticClass: "wizard step-3"
  }, [_c('success', {
    attrs: {
      "item": _vm.item
    }
  })], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdf8d584","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/ProjectWizard.vue
// module id = 1997
// module chunks = 0